"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _anglePatternInline = _interopRequireDefault(require("./angle-pattern.inline.svg"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var PreHeader = function PreHeader(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      _ref$colour = _ref.colour,
      colour = _ref$colour === void 0 ? 'seasonal' : _ref$colour;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.PreHeader, className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _indexModule.default.seasonal, colour === 'seasonal'), (0, _defineProperty2.default)(_classNames, _indexModule.default.minimal, colour === 'minimal'), (0, _defineProperty2.default)(_classNames, _indexModule.default.brand, colour === 'brand'), (0, _defineProperty2.default)(_classNames, _indexModule.default.black, colour === 'black'), _classNames)),
    role: "banner"
  }, /*#__PURE__*/_react.default.createElement(_anglePatternInline.default, {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement(_container.default, {
    className: _indexModule.default.container,
    type: "large"
  }, children));
};

PreHeader.propTypes = {
  className: _propTypes.default.string,
  colour: _propTypes.default.oneOf(['brand', 'minimal', 'seasonal', 'black'])
};
var _default = PreHeader;
exports.default = _default;